module.exports = {
    bindings: {
        nomenclatureLines: '<'
    },
    templateUrl: 'nomenclature/components/export-refund-nomenclature.html'
};